import {IPracticeService} from "./IPracticeService";
import {IPractice} from "shared/Practices/Entities/IPractice";
import practiceAPI from "shared/API/PracticeAPI";
import { PracticeListResponse } from "../../API/Responses/PracticeResponses";
export default class PracticeService implements IPracticeService {
  
  async addPractice(practice: IPractice): Promise<void> {
    return await practiceAPI.addPractice(practice);
  }

  async updatePractice(practice: IPractice): Promise<void> {
    return await practiceAPI.updatePractice(practice);
  }

  deletePractice(practice: IPractice): Promise<void> {
    return Promise.resolve(undefined);
  }

  async getPractices(offset: number, limit:number, searchTerm: string): Promise<PracticeListResponse> {  
    const result:PracticeListResponse = await (await practiceAPI.getPractices(offset,limit, searchTerm));
    return result;
  }

  async getPractice(id: number): Promise<IPractice> {
    return await practiceAPI.getPractice(id);
  }

  async getCurrentPractice(): Promise<IPractice> {
    return await practiceAPI.getCurrentPractice();
  }
}
